<template>
  <div class="isMember">
    <div class="flex space-between">
      <div class="member-header">
        <div class="header-box">
          <el-input
            placeholder="请输入手机号/姓名"
            v-model="memberMsg"
            @focus="handleFocus"
            @blur="hideBox"
            @input="changeInputValue"
            clearable
            style="small"
            maxlength="18"
            @clear="clearMember"
            class="input-with-select"
            prefix-icon="el-icon-search"
          />
          <el-button class="search-button" size="mini" @click="clickMember">搜索</el-button>
        </div>
      </div>
      <div class="member-box" v-if="focusHide && historyMobileList.length > 0">
        <div class="p10 history-box">
          <p>历史记录</p>
          <div class="flex-row">
            <div v-for="(item,index) in historyMobileList" :key="index">
              <!-- <el-button
                class="mt10 history-btn"
                @click="handleHistory(item)"
              >{{ item }}</el-button> -->
              <div class="not-btn">
                <el-button :key="index" class="mt10 history-btn" @click="handleHistory(item)">{{ item }}</el-button>
                <span
                  @click="removeShopBox(index,item)"
                  class="close-button el-icon-circle-close"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { },
  props: {
    mobile: {
      type: String,
      default: null
    },
    pageName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      memberMsg: "",
      list: {},
      form: {
        mobile: "",
      },
      focusHide: false,
      historyMobileList: [],
    };
  },
  created() {
    if (this.mobile) {
      this.memberMsg = this.mobile;
      // this.clickMember(this.list);
    }
  },
  watch: {
    mobile (o) {
      if (o) {
        this.memberMsg = this.mobile;
      }
    }
  },
  methods: {
    changeInputValue(value) {
      this.memberMsg = value;
      if (this.memberMsg.length == 18 || this.memberMsg.length == 11) {
        this.focusHide = false;
        this.$emit("handleChange", this.memberMsg);
      }
    },
    handleFocus(value) {
        let arr = JSON.parse(localStorage.getItem("historyMobileList"));
        console.log('数据：',arr);
        if (arr) {
          this.historyMobileList = arr;
        }
        this.focusHide = true;
    },
    hideBox() {
      setTimeout(() => {
        this.focusHide = false;
      }, 300);
    },
    removeShopBox(index, value) {
      let arr = [];
      if (JSON.parse(localStorage.getItem("historyMobileList"))) {
          arr = JSON.parse(localStorage.getItem("historyMobileList"));
      }
      arr.splice(index, 1);
      localStorage.setItem("historyMobileList", JSON.stringify(arr));
      this.historyMobileList = arr;
      if (this.historyMobileList.length > 0) {
        this.focusHide = true;
      }else {
        this.focusHide = false;
      }
    },
    handleHistory(msg) {
        this.clickMember();
        this.changeInputValue(msg);
    },
    handleInputHide() {
      this.memberMsg = "";
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
      this.$emit("handleUser", "");
    },
    clickMember() {
      if (this.memberMsg.length == 11) {
        this.$store.commit("setMemberMobile", this.memberMsg);
      }
      this.$store.commit("setMemberMobile", this.list.mobile);
      this.$emit("handleChange", this.memberMsg);
      this.$emit("handleUser", this.list);
    },
    clearMember() {
      this.focusHide = false;
      this.memberMsg = "";
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.isMember {
  position: relative;
  width: 100%;
  border-radius: 10px;
  // background: #fff;
}
.member-header {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  .header-box {
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }
  .search-button {
    position: absolute;
    top: 4px;
    right: 4px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    background: #3388FF;
  }
  /deep/ .el-input__inner {
    height: 48px;
  }
}
.ptb10 {
  padding: 10px;
}
.member-box {
  width: 100%;
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 99;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px rgba(31,47,67,0.2000);
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .bind-member-active {
      margin-left: 5px;
      margin-top: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
    margin-right: 10px;
  }
  .not-btn {
    position: relative;
    display: inline-block;
    /deep/ .el-button.is-disabled {
      background: #fff;
      border-color: #c6e2ff;
      color: #409eff;
    }
  }
  .close-button {
    position: absolute;
    right: 0;
    top: -1px;
    color: #999;
    font-size: 20px;
    cursor: pointer;
  }
}
.list {
  .flex-row {
    cursor: pointer;
    height: 60px;
    display: flex;
    align-items: center;
    margin: 0 10px 10px;
    padding-bottom: 10px;
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #F3F8FE;
    }
    
  }
  .member-box-yuanjian {
    display: flex;
    margin: 0 10px 10px;
    .member-box-yuanjian-list {
      padding: 0 30px 10px;
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
.member_bg {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  border-radius: 10px;
  .flex-row {
    align-items: center;
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
.flex {
  display: flex;
}
.toggleMember {
  width: 99px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  font-size: 14px;
  color: #3388FF;
  background: #FFF;
  border: 1px solid #EEE;
  border-radius: 18px;
  .toggleMember-img {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    img {
      margin-top: -1px;
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
</style>